import React, {useEffect, useState} from 'react';
import {useStores} from "../../stores/Context";
import {v4 as uuidv4} from "uuid";
import axios from "axios";
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    fas,
    faCalendarAlt,
    faChalkboard,
    faSpinner,
    faClock,
    faCloudSun,
    faDatabase,
    faDesktop,
    faLink,
    faRssSquare,
    faStickyNote,
    faEnvelope,
    faTimes,
    faExclamationCircle
} from "@fortawesome/free-solid-svg-icons";
import {faFacebook, faYoutube, fab} from "@fortawesome/free-brands-svg-icons";
import BtnSecondary from "../../boiteAOutils/BtnSecondary";
import PlusSvg from "../../boiteAOutils/SVG/PlusSvg";
import WidgetMessagesInterServicesSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetMessagesInterServicesSvg";
import WidgetConsignesSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetConsignesSvg";
import WidgetDateHeureSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetDateHeureSvg";
import WidgetIndicateurSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetIndicateurSvg";
import WidgetMeteoSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetMeteoSvg";
import WidgetPlanningActionsSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetPlanningActionsSvg";
import WidgetRssSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetRssSvg";
import WidgetURLSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetURLSvg";
import WidgetYoutubeSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetYoutubeSvg";
import styles from "./CreateForm.module.scss";
import WidgetTableauBlancSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetTableauBlancSvg";
import {useParams} from "react-router-dom";
import WidgetBibliothequeImagesSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetBibliothequeImagesSvg";
import WidgetRSPSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetRSPSvg";

library.add(
    fab,
    fas,
    faSpinner,
    faCalendarAlt,
    faChalkboard,
    faClock,
    faCloudSun,
    faDatabase,
    faDesktop,
    faLink,
    faRssSquare,
    faStickyNote,
    faEnvelope,
    faTimes,
    faFacebook,
    faYoutube,
    faExclamationCircle
)
const CreateChoixType = () => {
    const {uiStore, createWidgetStore, widgetStore} = useStores();
    const [listeChoixWidget, setListeChoixWidget] = useState([]);
    const [animation, setAnimation] = useState(1);
    const sidebarWidgets = widgetStore.widgetsAvailable;
    const [selectedCategory, setSelectedCategory] = useState('Tous les phidgets');
    const [categories, setCategories] = useState(['Tous les phidgets']);
    const [widgetExistence, setWidgetExistence] = useState({});

    // Récupération de l'ID de l'entreprise depuis l'URL
    const {ent} = useParams();
    // Récupération du cookie sous forme de chaîne
    const cookieEntreprise = widgetStore.getCookie((ent || "") + "_currentEntrepriseInfos") || widgetStore.getCookie("currentEntrepriseInfos");
    const entrepriseInfos = (() => {
        if (!cookieEntreprise) return {};
        try { return JSON.parse(cookieEntreprise); } catch (_) {
            try { return JSON.parse(decodeURIComponent(cookieEntreprise)); } catch (__) { return {}; }
        }
    })();


    const widgetsData = [
        {type: 'WidgetConsignes', label: 'Consignes', icon: <WidgetConsignesSvg width="40" height="40"/>},
        {type: 'WidgetDateHeure', label: 'Date / Heure', icon: <WidgetDateHeureSvg width="40" height="40"/>},
        {type: 'WidgetIndicateur', label: 'Indicateur', icon: <WidgetIndicateurSvg width="40" height="40"/>},
        {
            type: 'WidgetMessagesInterServices',
            label: 'Messages internes',
            icon: <WidgetMessagesInterServicesSvg width="40" height="40"/>
        },
        {type: 'WidgetMeteo', label: 'Météo', icon: <WidgetMeteoSvg width="40" height="40"/>},
        {
            type: 'WidgetPlanningActions',
            label: 'Planning d\'actions',
            icon: <WidgetPlanningActionsSvg width="40" height="40"/>
        },
        {type: 'WidgetRss', label: 'Flux Rss', icon: <WidgetRssSvg width="40" height="40"/>},
        {type: 'WidgetURL', label: 'Page web', icon: <WidgetURLSvg width="40" height="40"/>},
        {type: 'WidgetYoutube', label: 'Youtube', icon: <WidgetYoutubeSvg width="40" height="40"/>},
        {type: 'WidgetTableauBlanc', label: 'Tableau blanc', icon: <WidgetTableauBlancSvg width="40" height="40"/>},
        {type: 'WidgetBibliothequeImages', label: 'WidgetBibliothequeImages', icon: <WidgetBibliothequeImagesSvg width="40" height="40"/>},
        {type: 'WidgetRSP', label: 'Résolution de problèmes', icon: <WidgetRSPSvg width="40" height="40"/>},
    ];
    // Liste des types de widgets qui ne peuvent être ajoutés qu'une seule fois
    const uniqueWidgets = entrepriseInfos.subscriber ?
        // Si l'utilisateur est abonné, il peut ajouter plusieurs fois les widgets
        ['WidgetConsignes', 'WidgetDateHeure', 'WidgetMessagesInterServices', 'WidgetBibliothequeImages']
        :
        // Sinon, il ne peut ajouter qu'un seul widget par type
        [
            'WidgetConsignes',
            'WidgetIndicateur',
            'WidgetDateHeure',
            'WidgetMessagesInterServices',
            'WidgetPlanningActions',
            'WidgetBibliothequeImages',
            'WidgetMeteo',
            'WidgetRss',
            'WidgetURL',
            'WidgetYoutube',
            'WidgetTableauBlanc'
        ];

    useEffect(() => {
        const existence = {};
        uniqueWidgets.forEach(widgetType => {
            existence[widgetType] = sidebarWidgets.some(data => data.typeWidget === widgetType);
        });
        setWidgetExistence(existence);
    }, [sidebarWidgets]);


    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + '/api/listeChoixWidget',
            {headers: {"Authorization": `Bearer ${widgetStore._token}`}})
            .then((res) => {
                if (res.data.length > 0) {
                    // trie croissant de la reponse
                    let listeWidget = res.data.sort(function (a, b) {
                        if (a.nom < b.nom) {
                            return -1;
                        }
                        if (a.nom > b.nom) {
                            return 1;
                        }
                        return 0;
                    });

                    const categorySet = new Set([]);
                    listeWidget = listeWidget.map(widget => {
                        if (widget.type.includes('WidgetDateHeure')
                            || widget.type.includes('WidgetMeteo')
                            || widget.type.includes('WidgetYoutube')
                            || widget.type.includes('WidgetURL')
                            || widget.type.includes('WidgetRss')
                            || widget.type.includes('WidgetBibliothequeImages')) {
                            widget.category = 'Basiques';
                        } else if (widget.type.includes('WidgetPlanningActions') || widget.type.includes('WidgetConsignes') || widget.type.includes('WidgetMessagesInterServices') || widget.type.includes('WidgetTableauBlanc')) {
                            widget.category = 'Collaboratifs';
                        } else if (widget.type.includes('WidgetIndicateur')) {
                            widget.category = 'Indicateur';
                        } else {
                            widget.category = 'Autres';
                        }
                        categorySet.add(widget.category);
                        return widget;
                    });

                    setCategories(['Tous les phidgets', ...Array.from(categorySet).sort()]);
                    setListeChoixWidget(listeWidget);
                } else {
                    // Affichage icone + texte pour information qu"il n'y a aucun widget
                    setAnimation(2) // default animation = 1, pour un spinner loading
                }
            });
    }, []);

    const handleOpenCreationForm = (typeWidget) => {
        if (typeWidget === "WidgetDateHeure") {
            widgetStore.addWidgetAvailable({
                idWidget: uuidv4()
                , typeWidget: 'WidgetDateHeure'
                , nomWidget: 'Date / Heure'
                , config: {}
            });
            uiStore.backNivOAfterAddPhidget();
        } else if (typeWidget === "WidgetMessagesInterServices") {
            widgetStore.addWidgetAvailable({
                idWidget: uuidv4()
                , typeWidget: 'WidgetMessagesInterServices'
                , nomWidget: 'Messages internes'
                , config: {}
            });
            uiStore.backNivOAfterAddPhidget();
        } else if (typeWidget === "WidgetBibliothequeImages") {
            widgetStore.addWidgetAvailable({
                idWidget: uuidv4()
                , typeWidget: 'WidgetBibliothequeImages'
                , nomWidget: 'Mes images'
                , config: {}
            });
            uiStore.backNivOAfterAddPhidget();
        } else {
            createWidgetStore.openCreationMode(typeWidget);
        }
    }

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
    };

    return (
        listeChoixWidget.length > 0 ?
            (
                <>
                    <div className={"createPhidgetChoixTitleContent"}>
                        <h1 className={"createPhidgetChoixTitle"}>
                            Bibliothèque des phidgets
                        </h1>
                        <span className={"createPhidgetChoixTitleDescription"}>
                            Parcourir les phidgets disponibles pour votre borne sur le terrain.
                        </span>
                    </div>

                    <div className={styles.containerChoixTypePhidget}>
                        <div className={"createPhidgetChoixType"}>
                            <span className={"createPhidgetChoixTypeTitle"}>Choisir par type :</span>
                            <span style={{width: "12em", height: "1px", background: "#DBE3E7"}}></span>
                            <div className={"createPhidgetChoixTypeBtnContent"}>
                                {categories.map((category) => (
                                    <div
                                        key={category}
                                        className={`createPhidgetChoixTypeBtnMenu ${selectedCategory === category ? 'active' : ''}`}
                                        onClick={() => handleCategoryChange(category)}
                                    >
                                        <span>{category}</span>
                                        <span>{listeChoixWidget.filter(widget => category === 'Tous les phidgets' || widget.category === category).length}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="createPhidgetContent">
                            {listeChoixWidget.filter(widget => selectedCategory === 'Tous les phidgets' || widget.category === selectedCategory).map((item, k) => {
                                const widgetData = widgetsData.find(w => w.type === item.type);

                                if (item.active === 'true') {
                                    const widgetExists = widgetExistence[item.type] || false;

                                    return (
                                        <div className="createPhidgetCard" key={k}>
                                            <div style={{display: "flex", alignItems: "center"}}>
                                                {widgetData?.icon} {/* Affiche l'icône SVG du widget */}
                                                <span className="createPhidgetCardTitle">{item.nom}</span>
                                            </div>
                                            {widgetExists ?
                                                <BtnSecondary styleSpan={{display: "flex", fontSize: "12px"}}
                                                              disabled={true}>
                                                    {entrepriseInfos.subscriber ? "Le phidget existe déjà" : "Limite Freemium atteinte"}

                                                </BtnSecondary> : (
                                                    <BtnSecondary onClick={() => handleOpenCreationForm(item.type)}
                                                                  styleSpan={{display: "flex", fontSize: "12px"}}>
                                                        <PlusSvg width={16} height={16} couleur={"#002335"}/> Ajouter ce
                                                        phidget
                                                    </BtnSecondary>
                                                )
                                            }
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    </div>
                </>
            ) : animation === 1 ?
                (
                    <FontAwesomeIcon icon={"spinner"} spin size="6x" style={{color: '#1976d2'}}/>
                ) : (
                    <>
                        <FontAwesomeIcon icon={"exclamation-circle"} size="6x" style={{color: 'red'}}/>
                        <p>Aucun phidget disponible, veuillez réessayer plus tard ou contacter un administrateur</p>
                    </>
                )
    );
};

export default CreateChoixType;
